import Vue from 'vue';
import SearchList from './SearchList.vue';
import InstantSearch from 'vue-instantsearch';

Vue.use(InstantSearch);

new Vue({
  el: '#svv_search_list',
  render: (h) => h(SearchList), //VERKSAMHETER SEARCH SHORTCODE
  created: () => {
    // eslint-disable-next-line
    console.log(
      'Algolia search for Verksamheter: "verksamheter_search" init. '
    );
  },
});
